export default "__VITE_ASSET__B28PDP7e__"